import countries from "@/constants/countries.json";

// Define supported languages
export type SupportedLanguage = "ar" | "en";
export const supportedLanguages: SupportedLanguage[] = ["ar", "en"]; // Add all supported languages
export const defaultLanguage: SupportedLanguage = "ar";

// Get supported countries based on supported languages
export const supportedLanguagesFromCountries = supportedLanguages.map(
  (language) => {
    const country = countries.find((country) => country.language === language);
    return country
      ? {
          name: country.languageName,
          language: language,
          imageCircle: country.imageCircle,
        }
      : { name: language, language: language };
  }
);

export const status = {};
